import './LoadingCustom.scss';

interface LoadingProps {
  message?: string;
  isLoading?: boolean;
}

export default function LoadingCustom({ isLoading = false, message = 'Đang tải...' }: LoadingProps) {
  if (!isLoading) return null;

  return (
    <div className='loading-container'>
      <div className='loading-content'>
        <div className='loading-spinner'>
          <div className='loading-dot loading-dot-1' />
          <div className='loading-dot loading-dot-2' />
          <div className='loading-dot loading-dot-3' />
        </div>
        <p className='loading-text'>{message}</p>
      </div>
    </div>
  );
}
